const DEFAULT_STATISTIC_VALUE = "0";

export { DEFAULT_STATISTIC_VALUE };
